module.exports = __webpack_public_path__ + "static/media/Food1.1690a0a7.png";